import React, {Suspense, lazy} from 'react';
import {Route, Routes} from "react-router-dom";
import LinearProgress from '@mui/material/LinearProgress';
import Box from "@mui/material/Box";
import NotFoundPage from "../../pages/404/notFoundPage";
import PrivateRoute from "./PrivateRoute";
import {useGetUserAuthStatusQuery} from "../../features/user/userSlice";

const Condition = lazy(() => import("../../pages/condition"))
const CompleteInformation = lazy(() => import("../../pages/completeInformation"))
const FacilitySelection = lazy(() => import("../../pages/facilitySelection"))
const BankError = lazy(() => import("../../pages/bankError"))
const RequestInquiry = lazy(() => import("../../pages/requestInquiry"))
const CreditScoreInquiry = lazy(() => import("../../pages/creditScoreInquiry"))
const InstallApplication = lazy(() => import("../../pages/installApplication"))
const CreditScoreCalculation = lazy(() => import("../../pages/creditScoreCalculation"))
const DeliveryGuaranteeCheck = lazy(() => import("../../pages/deliveryGuaranteeCheck"))
const DeliveryGuaranteeCheckFail = lazy(() => import("../../pages/deliveryGuaranteeCheckFail"))
const DeliveryGuaranteeSuccess = lazy(() => import("../../pages/deliveryGuaranteeSuccess"))
const UploadDocuments = lazy(() => import("../../pages/uploadDocuments"))
const DeliveryRemainingTime = lazy(() => import("../../pages/deliveryRemainingTime"))
const DepositToWalletSucceed = lazy(() => import("../../pages/depositToWalletSucceed"))
const DepositToWalletFailed = lazy(() => import("../../pages/depositToWalletFailed"))

const RoutesComponent = () => {
    const {data, isLoading, error} = useGetUserAuthStatusQuery()

    return (
        <Routes>
            <Route path={'/'} element={
                <PrivateRoute>
                    <Suspense fallback={<Box width={'100%'}><LinearProgress color={"primary"}/></Box>}>
                        <Condition userData={data} isLoading={isLoading} pathname={'/'}/>
                    </Suspense>
                </PrivateRoute>
            }/>
            <Route path={'facility-selection'} element={
                <PrivateRoute>
                    <Suspense fallback={<Box width={'100%'}><LinearProgress color={"primary"}/></Box>}>
                        <FacilitySelection/>
                    </Suspense>
                </PrivateRoute>
            }/>
            <Route path={'completion-information'} element={
                <PrivateRoute>
                    <Suspense fallback={<Box width={'100%'}><LinearProgress color={"primary"}/></Box>}>
                        <CompleteInformation/>
                    </Suspense>
                </PrivateRoute>
            }/>
            <Route path={'request-inquiry'} element={
                <PrivateRoute>
                    <Suspense fallback={<Box width={'100%'}><LinearProgress color={"primary"}/></Box>}>
                        <RequestInquiry/>
                    </Suspense>
                </PrivateRoute>
            }/>
            <Route path={'credit-score-inquiry'} element={
                <PrivateRoute>
                    <Suspense fallback={<Box width={'100%'}><LinearProgress color={"primary"}/></Box>}>
                        <CreditScoreInquiry/>
                    </Suspense>
                </PrivateRoute>
            }/>
            <Route path={'credit-score-calculation'} element={
                <PrivateRoute>
                    <Suspense fallback={<Box width={'100%'}><LinearProgress color={"primary"}/></Box>}>
                        <CreditScoreCalculation/>
                    </Suspense>
                </PrivateRoute>
            }/>
            <Route path={'bank-error'} element={
                <PrivateRoute>
                    <Suspense fallback={<Box width={'100%'}><LinearProgress color={"primary"}/></Box>}>
                        <BankError/>
                    </Suspense>
                </PrivateRoute>
            }/>
            <Route path={'upload-documents'} element={
                <PrivateRoute>
                    <Suspense fallback={<Box width={'100%'}><LinearProgress color={"primary"}/></Box>}>
                        <UploadDocuments/>
                    </Suspense>
                </PrivateRoute>
            }/>
            <Route path={'delivery-guarantee-check'} element={
                <PrivateRoute>
                    <Suspense fallback={<Box width={'100%'}><LinearProgress color={"primary"}/></Box>}>
                        <DeliveryGuaranteeCheck/>
                    </Suspense>
                </PrivateRoute>
            }/>
            <Route path={'delivery-guarantee-check-success'} element={
                <PrivateRoute>
                    <Suspense fallback={<Box width={'100%'}><LinearProgress color={"primary"}/></Box>}>
                        <DeliveryGuaranteeSuccess/>
                    </Suspense>
                </PrivateRoute>
            }/>
            <Route path={'delivery-guarantee-check-fail'} element={
                <PrivateRoute>
                    <Suspense fallback={<Box width={'100%'}><LinearProgress color={"primary"}/></Box>}>
                        <DeliveryGuaranteeCheckFail/>
                    </Suspense>
                </PrivateRoute>
            }/>
            <Route path={'deposit-to-wallet-succeed'} element={
                <PrivateRoute>
                    <Suspense fallback={<Box width={'100%'}><LinearProgress color={"primary"}/></Box>}>
                        <DepositToWalletSucceed/>
                    </Suspense>
                </PrivateRoute>
            }/>
              <Route path={'deposit-to-wallet-failed'} element={
                <PrivateRoute>
                    <Suspense fallback={<Box width={'100%'}><LinearProgress color={"primary"}/></Box>}>
                        <DepositToWalletFailed/>
                    </Suspense>
                </PrivateRoute>
            }/>
            <Route path={'install-app'} element={
                <PrivateRoute>
                    <Suspense
                        fallback={<Box width={'100%'}><LinearProgress color={"primary"}/></Box>}>
                        <InstallApplication/>
                    </Suspense>
                </PrivateRoute>
            }/>
            <Route path={'delivery-remaining-time'} element={
                <PrivateRoute>
                    <Suspense
                        fallback={<Box width={'100%'}><LinearProgress color={"primary"}/></Box>}>
                        <DeliveryRemainingTime/>
                    </Suspense>
                </PrivateRoute>
            }/>
            <Route path="*" element={<NotFoundPage/>}/>
        </Routes>
    );
};

export default RoutesComponent;